function G(e) {
  if (e.length === 0)
    return null;
  const r = e[0];
  return r.isGroup || r.ignored || r.disabled ? r.getNext() : r;
}
function v(e, r) {
  const n = e.siblings, s = n.length, { index: i } = e;
  return r ? n[(i + 1) % s] : i === n.length - 1 ? null : n[i + 1];
}
function h(e, r, { loop: n = !1, includeDisabled: s = !1 } = {}) {
  const i = r === "prev" ? d : v, a = {
    reverse: r === "prev"
  };
  let f = !1, c = null;
  function l(t) {
    if (t !== null) {
      if (t === e) {
        if (!f)
          f = !0;
        else if (!e.disabled && !e.isGroup) {
          c = e;
          return;
        }
      } else if ((!t.disabled || s) && !t.ignored && !t.isGroup) {
        c = t;
        return;
      }
      if (t.isGroup) {
        const u = g(t, a);
        u !== null ? c = u : l(i(t, n));
      } else {
        const u = i(t, !1);
        if (u !== null)
          l(u);
        else {
          const o = p(t);
          o != null && o.isGroup ? l(i(o, n)) : n && l(i(t, !0));
        }
      }
    }
  }
  return l(e), c;
}
function d(e, r) {
  const n = e.siblings, s = n.length, { index: i } = e;
  return r ? n[(i - 1 + s) % s] : i === 0 ? null : n[i - 1];
}
function p(e) {
  return e.parent;
}
function g(e, r = {}) {
  const { reverse: n = !1 } = r, { children: s } = e;
  if (s) {
    const { length: i } = s, a = n ? i - 1 : 0, f = n ? -1 : i, c = n ? -1 : 1;
    for (let l = a; l !== f; l += c) {
      const t = s[l];
      if (!t.disabled && !t.ignored)
        if (t.isGroup) {
          const u = g(t, r);
          if (u !== null)
            return u;
        } else
          return t;
    }
  }
  return null;
}
const b = {
  getChild() {
    return this.ignored ? null : g(this);
  },
  getParent() {
    const { parent: e } = this;
    return e != null && e.isGroup ? e.getParent() : e;
  },
  getNext(e = {}) {
    return h(this, "next", e);
  },
  getPrev(e = {}) {
    return h(this, "prev", e);
  }
};
export {
  G as getFirstAvailableNode,
  b as moveMethods
};
